<div class="loading" *ngIf="visible">
    <p-progressSpinner></p-progressSpinner>
</div>
